"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingSourceReviewSkipReason = exports.FundingSourceReviewStatus = exports.HUMAN_READABLE_ASSET_VERIFICATION_DENIAL_REASON = exports.AssetVerificationDenialReason = exports.ASSET_VERIFICATION_FUNDING_SOURCE_TO_DOCUMENT_TYPES = exports.supportedFirstLienPurchaseDocuments = exports.ASSET_FUNDING_SOURCE_DOCUMENT_TYPES = exports.ASSET_VERIFICATION_CATEGORY_TO_FUNDING_SOURCES = exports.AssetVerificationFundingSourceCategory = exports.AssetVerificationFundingSources = exports.ASSET_VERIFICATION_STATUS_NO_ACTION_REQUIRED = exports.AssetVerificationStatus = exports.ASSET_VERIFICATION_RESULT_NO_ACTION_REQUIRED = exports.AssetVerificationResultType = exports.AssetVerificationMethod = exports.AssetVerificationPurpose = exports.AssetVerificationProgressStatus = void 0;
const documentUpload_1 = require("./documentUpload");
var AssetVerificationProgressStatus;
(function (AssetVerificationProgressStatus) {
    AssetVerificationProgressStatus["pending"] = "pending";
    AssetVerificationProgressStatus["completed"] = "completed";
    AssetVerificationProgressStatus["failed"] = "failed";
})(AssetVerificationProgressStatus || (exports.AssetVerificationProgressStatus = AssetVerificationProgressStatus = {}));
/* @TranslateToPython @TranslateToEnum */
var AssetVerificationPurpose;
(function (AssetVerificationPurpose) {
    AssetVerificationPurpose["ucc"] = "ucc";
    /**
     * @deprecated Use firstLienPurchaseCashToClose instead.
     * Persisted in active queue-item JSON before the cash-to-close terminology correction.
     */
    AssetVerificationPurpose["_firstLienPurchaseDownPayment"] = "firstLienPurchaseDownPayment";
    AssetVerificationPurpose["firstLienPurchaseCashToClose"] = "firstLienPurchaseCashToClose";
})(AssetVerificationPurpose || (exports.AssetVerificationPurpose = AssetVerificationPurpose = {}));
var AssetVerificationMethod;
(function (AssetVerificationMethod) {
    AssetVerificationMethod["plaid"] = "plaid";
    AssetVerificationMethod["bankStatements"] = "bankStatements";
    AssetVerificationMethod["manual"] = "manual";
    AssetVerificationMethod["unknown"] = "unknown";
})(AssetVerificationMethod || (exports.AssetVerificationMethod = AssetVerificationMethod = {}));
/* @TranslateToPython @TranslateToEnum */
var AssetVerificationResultType;
(function (AssetVerificationResultType) {
    AssetVerificationResultType["assetsVerifiedAndSufficient"] = "assetsVerifiedAndSufficient";
    AssetVerificationResultType["assetsVerifiedAndInsufficient"] = "assetsVerifiedAndInsufficient";
    AssetVerificationResultType["assetVerificationNotApplicable"] = "assetVerificationNotApplicable";
    AssetVerificationResultType["cannotInitiateAssetVerification"] = "cannotInitiateAssetVerification";
    AssetVerificationResultType["assetsRequireManualReview"] = "assetsRequireManualReview";
    AssetVerificationResultType["awaitingPlaidConnection"] = "awaitingPlaidConnection";
})(AssetVerificationResultType || (exports.AssetVerificationResultType = AssetVerificationResultType = {}));
exports.ASSET_VERIFICATION_RESULT_NO_ACTION_REQUIRED = [AssetVerificationResultType.assetsVerifiedAndSufficient, AssetVerificationResultType.assetVerificationNotApplicable];
var AssetVerificationStatus;
(function (AssetVerificationStatus) {
    AssetVerificationStatus["notApplicable"] = "notApplicable";
    AssetVerificationStatus["pending"] = "pending";
    AssetVerificationStatus["verifiedAndSufficient"] = "verifiedAndSufficient";
    AssetVerificationStatus["verifiedAndInsufficient"] = "verifiedAndInsufficient";
    AssetVerificationStatus["notVerified"] = "notVerified";
})(AssetVerificationStatus || (exports.AssetVerificationStatus = AssetVerificationStatus = {}));
exports.ASSET_VERIFICATION_STATUS_NO_ACTION_REQUIRED = [AssetVerificationStatus.notApplicable, AssetVerificationStatus.verifiedAndSufficient];
// The granular funding sources an applicant can classify a flagged transaction as. Each is a DocumentUploadType
// member (single source of truth per aven_types/AGENTS.md) so the classification persists directly on
// asset_transaction.funding_source without a parallel enum. PENSION is reused from the shared document types.
exports.AssetVerificationFundingSources = [
    // Employment & Income
    documentUpload_1.DocumentUploadType.PAYROLL_DIRECT_DEPOSIT,
    documentUpload_1.DocumentUploadType.BONUS,
    documentUpload_1.DocumentUploadType.COMMISSION,
    documentUpload_1.DocumentUploadType.OVERTIME_PAY,
    documentUpload_1.DocumentUploadType.TIPS,
    documentUpload_1.DocumentUploadType.SEVERANCE_PAY,
    documentUpload_1.DocumentUploadType.PTO_PAY_OUT,
    documentUpload_1.DocumentUploadType.EXPENSE_REIMBURSEMENT,
    documentUpload_1.DocumentUploadType.INDEPENDENT_CONTRACTOR_INCOME,
    documentUpload_1.DocumentUploadType.SELF_EMPLOYMENT_BUSINESS_INCOME,
    // Retirement & Government Benefits
    documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_RETIREMENT,
    documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_DISABILITY,
    documentUpload_1.DocumentUploadType.SUPPLEMENTAL_SECURITY_INCOME,
    documentUpload_1.DocumentUploadType.PENSION,
    documentUpload_1.DocumentUploadType.ANNUITY_PAYMENTS,
    documentUpload_1.DocumentUploadType.VETERANS_BENEFITS,
    documentUpload_1.DocumentUploadType.RAILROAD_RETIREMENT,
    documentUpload_1.DocumentUploadType.STATE_RETIREMENT_BENEFITS,
    documentUpload_1.DocumentUploadType.MILITARY_RETIREMENT,
    // Transfers
    documentUpload_1.DocumentUploadType.TRANSFER_FROM_PERSONAL_ACCOUNT,
    documentUpload_1.DocumentUploadType.TRANSFER_FROM_JOINT_ACCOUNT,
    documentUpload_1.DocumentUploadType.BROKERAGE_ACCOUNT_TRANSFER,
    documentUpload_1.DocumentUploadType.SAVINGS_ACCOUNT_TRANSFER,
    documentUpload_1.DocumentUploadType.CREDIT_UNION_TRANSFER,
    documentUpload_1.DocumentUploadType.MONEY_MARKET_TRANSFER,
    documentUpload_1.DocumentUploadType.TRUST_ACCOUNT_TRANSFER,
    documentUpload_1.DocumentUploadType.CD_MATURITY_PROCEEDS,
    documentUpload_1.DocumentUploadType.INTERNATIONAL_WIRE_TRANSFER,
    documentUpload_1.DocumentUploadType.INTERNAL_BANK_TRANSFER,
    // Sale of Assets
    documentUpload_1.DocumentUploadType.SALE_OF_HOME,
    documentUpload_1.DocumentUploadType.SALE_OF_LAND,
    documentUpload_1.DocumentUploadType.SALE_OF_VEHICLE,
    documentUpload_1.DocumentUploadType.SALE_OF_BOAT,
    documentUpload_1.DocumentUploadType.SALE_OF_RV,
    documentUpload_1.DocumentUploadType.SALE_OF_MOTORCYCLE,
    documentUpload_1.DocumentUploadType.SALE_OF_BUSINESS,
    documentUpload_1.DocumentUploadType.SALE_OF_STOCKS,
    documentUpload_1.DocumentUploadType.SALE_OF_BONDS,
    documentUpload_1.DocumentUploadType.SALE_OF_MUTUAL_FUNDS,
    documentUpload_1.DocumentUploadType.SALE_OF_CRYPTOCURRENCY,
    documentUpload_1.DocumentUploadType.SALE_OF_COLLECTIBLES,
    documentUpload_1.DocumentUploadType.ESTATE_SALE_PROCEEDS,
    // Investments
    documentUpload_1.DocumentUploadType.STOCK_DIVIDENDS,
    documentUpload_1.DocumentUploadType.BOND_INTEREST,
    documentUpload_1.DocumentUploadType.MUTUAL_FUND_DISTRIBUTION,
    documentUpload_1.DocumentUploadType.CAPITAL_GAINS_DISTRIBUTION,
    documentUpload_1.DocumentUploadType.INVESTMENT_ACCOUNT_WITHDRAWAL,
    documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_DISTRIBUTION,
    documentUpload_1.DocumentUploadType.REQUIRED_MINIMUM_DISTRIBUTION,
    // Insurance
    documentUpload_1.DocumentUploadType.LIFE_INSURANCE_PAYOUT,
    documentUpload_1.DocumentUploadType.HEALTH_INSURANCE_REIMBURSEMENT,
    documentUpload_1.DocumentUploadType.AUTO_INSURANCE_CLAIM,
    documentUpload_1.DocumentUploadType.HOMEOWNERS_INSURANCE_CLAIM,
    documentUpload_1.DocumentUploadType.DISABILITY_INSURANCE_BENEFITS,
    documentUpload_1.DocumentUploadType.LONG_TERM_CARE_INSURANCE_PAYOUT,
    // Real Estate
    documentUpload_1.DocumentUploadType.RENTAL_INCOME,
    documentUpload_1.DocumentUploadType.SECURITY_DEPOSIT_REFUND,
    documentUpload_1.DocumentUploadType.ESCROW_REFUND,
    documentUpload_1.DocumentUploadType.PROPERTY_TAX_REFUND,
    documentUpload_1.DocumentUploadType.MORTGAGE_ESCROW_SURPLUS,
    documentUpload_1.DocumentUploadType.HOME_EQUITY_LOAN_PROCEEDS,
    documentUpload_1.DocumentUploadType.HELOC_ADVANCE,
    documentUpload_1.DocumentUploadType.CASH_OUT_REFINANCE_PROCEEDS,
    documentUpload_1.DocumentUploadType.HOME_SALE_PROCEEDS,
    // Loans
    documentUpload_1.DocumentUploadType.PERSONAL_LOAN_PROCEEDS,
    documentUpload_1.DocumentUploadType.AUTO_LOAN_PROCEEDS,
    documentUpload_1.DocumentUploadType.STUDENT_LOAN_DISBURSEMENT,
    documentUpload_1.DocumentUploadType.BUSINESS_LOAN_PROCEEDS,
    documentUpload_1.DocumentUploadType.SBA_LOAN_PROCEEDS,
    documentUpload_1.DocumentUploadType.CONSTRUCTION_LOAN_DRAW,
    documentUpload_1.DocumentUploadType.PRIVATE_LOAN_FROM_FAMILY_FRIEND,
    documentUpload_1.DocumentUploadType.MARGIN_LOAN,
    documentUpload_1.DocumentUploadType.LINE_OF_CREDIT_ADVANCE,
    // Gifts & Family
    documentUpload_1.DocumentUploadType.GIFT_FROM_FAMILY_MEMBER,
    documentUpload_1.DocumentUploadType.GIFT_FROM_FRIEND,
    documentUpload_1.DocumentUploadType.WEDDING_GIFT,
    documentUpload_1.DocumentUploadType.GRADUATION_GIFT,
    documentUpload_1.DocumentUploadType.BIRTHDAY_GIFT,
    documentUpload_1.DocumentUploadType.INHERITANCE,
    documentUpload_1.DocumentUploadType.TRUST_DISTRIBUTION,
    // Legal & Settlement
    documentUpload_1.DocumentUploadType.LAWSUIT_SETTLEMENT,
    documentUpload_1.DocumentUploadType.CLASS_ACTION_SETTLEMENT,
    documentUpload_1.DocumentUploadType.WORKERS_COMPENSATION_SETTLEMENT,
    documentUpload_1.DocumentUploadType.PERSONAL_INJURY_SETTLEMENT,
    documentUpload_1.DocumentUploadType.DIVORCE_SETTLEMENT,
    documentUpload_1.DocumentUploadType.CHILD_SUPPORT_PAYMENT,
    documentUpload_1.DocumentUploadType.ALIMONY,
    documentUpload_1.DocumentUploadType.ESTATE_DISTRIBUTION,
    // Business
    documentUpload_1.DocumentUploadType.CUSTOMER_PAYMENTS,
    documentUpload_1.DocumentUploadType.MERCHANT_SERVICES_DEPOSITS,
    documentUpload_1.DocumentUploadType.ACCOUNTS_RECEIVABLE_COLLECTIONS,
    documentUpload_1.DocumentUploadType.VENDOR_REFUND,
    documentUpload_1.DocumentUploadType.TAX_REFUND_TO_BUSINESS,
    documentUpload_1.DocumentUploadType.OWNER_CONTRIBUTION,
    documentUpload_1.DocumentUploadType.PARTNER_CAPITAL_CONTRIBUTION,
    documentUpload_1.DocumentUploadType.BUSINESS_INSURANCE_CLAIM,
    // Tax-Related
    documentUpload_1.DocumentUploadType.FEDERAL_INCOME_TAX_REFUND,
    documentUpload_1.DocumentUploadType.STATE_INCOME_TAX_REFUND,
    documentUpload_1.DocumentUploadType.SALES_TAX_REFUND,
    documentUpload_1.DocumentUploadType.IRS_CREDIT_OR_REBATE,
    // Education
    documentUpload_1.DocumentUploadType.STUDENT_FINANCIAL_AID_REFUND,
    documentUpload_1.DocumentUploadType.SCHOLARSHIP_REFUND,
    documentUpload_1.DocumentUploadType.GRANT_PROCEEDS,
    documentUpload_1.DocumentUploadType.TUITION_REIMBURSEMENT,
    // Gambling & Gaming
    documentUpload_1.DocumentUploadType.CASINO_WINNINGS,
    documentUpload_1.DocumentUploadType.LOTTERY_WINNINGS,
    documentUpload_1.DocumentUploadType.SPORTS_BETTING_WINNINGS,
    documentUpload_1.DocumentUploadType.POKER_TOURNAMENT_WINNINGS,
    documentUpload_1.DocumentUploadType.SWEEPSTAKES_PRIZE,
    // Online Platforms
    documentUpload_1.DocumentUploadType.PAYPAL_TRANSFER,
    documentUpload_1.DocumentUploadType.VENMO_TRANSFER,
    documentUpload_1.DocumentUploadType.CASH_APP_TRANSFER,
    documentUpload_1.DocumentUploadType.ZELLE_PAYMENT,
    documentUpload_1.DocumentUploadType.STRIPE_PAYOUT,
    documentUpload_1.DocumentUploadType.SQUARE_PAYOUT,
    documentUpload_1.DocumentUploadType.ETSY_PAYOUT,
    documentUpload_1.DocumentUploadType.EBAY_PAYOUT,
    documentUpload_1.DocumentUploadType.AMAZON_SELLER_PAYOUT,
    documentUpload_1.DocumentUploadType.AIRBNB_PAYOUT,
    documentUpload_1.DocumentUploadType.VRBO_PAYOUT,
    documentUpload_1.DocumentUploadType.UBER_LYFT_EARNINGS,
    documentUpload_1.DocumentUploadType.DOOR_DASH_INSTACART_EARNINGS,
    // Cash Deposits
    documentUpload_1.DocumentUploadType.PERSONAL_CASH_SAVINGS,
    documentUpload_1.DocumentUploadType.CASH_FROM_BUSINESS_RECEIPTS,
    documentUpload_1.DocumentUploadType.CASH_GIFT,
    documentUpload_1.DocumentUploadType.CASH_FROM_SALE_OF_PERSONAL_PROPERTY,
    // Refunds & Credits
    documentUpload_1.DocumentUploadType.MERCHANT_REFUND,
    documentUpload_1.DocumentUploadType.CREDIT_CARD_REFUND,
    documentUpload_1.DocumentUploadType.UTILITY_DEPOSIT_REFUND,
    documentUpload_1.DocumentUploadType.WARRANTY_REIMBURSEMENT,
    documentUpload_1.DocumentUploadType.MANUFACTURER_REBATE,
    // Miscellaneous
    documentUpload_1.DocumentUploadType.PRIZE_OR_AWARD,
    documentUpload_1.DocumentUploadType.ROYALTIES,
    documentUpload_1.DocumentUploadType.LICENSING_INCOME,
    documentUpload_1.DocumentUploadType.PATENT_INCOME,
    documentUpload_1.DocumentUploadType.COPYRIGHT_INCOME,
    documentUpload_1.DocumentUploadType.MINERAL_OR_OIL_RIGHTS_ROYALTIES,
    documentUpload_1.DocumentUploadType.CROWDFUNDING_PROCEEDS,
    documentUpload_1.DocumentUploadType.CHARITABLE_GRANT,
    documentUpload_1.DocumentUploadType.CHURCH_ASSISTANCE,
    documentUpload_1.DocumentUploadType.DISASTER_RELIEF_FUNDS,
    documentUpload_1.DocumentUploadType.FOREIGN_CURRENCY_EXCHANGE_PROCEEDS,
];
var AssetVerificationFundingSourceCategory;
(function (AssetVerificationFundingSourceCategory) {
    AssetVerificationFundingSourceCategory["EMPLOYMENT_AND_INCOME"] = "EMPLOYMENT_AND_INCOME";
    AssetVerificationFundingSourceCategory["RETIREMENT_AND_GOVERNMENT_BENEFITS"] = "RETIREMENT_AND_GOVERNMENT_BENEFITS";
    AssetVerificationFundingSourceCategory["TRANSFERS"] = "TRANSFERS";
    AssetVerificationFundingSourceCategory["SALE_OF_ASSETS"] = "SALE_OF_ASSETS";
    AssetVerificationFundingSourceCategory["INVESTMENTS"] = "INVESTMENTS";
    AssetVerificationFundingSourceCategory["INSURANCE"] = "INSURANCE";
    AssetVerificationFundingSourceCategory["REAL_ESTATE"] = "REAL_ESTATE";
    AssetVerificationFundingSourceCategory["LOANS"] = "LOANS";
    AssetVerificationFundingSourceCategory["GIFTS_AND_FAMILY"] = "GIFTS_AND_FAMILY";
    AssetVerificationFundingSourceCategory["LEGAL_AND_SETTLEMENT"] = "LEGAL_AND_SETTLEMENT";
    AssetVerificationFundingSourceCategory["BUSINESS"] = "BUSINESS";
    AssetVerificationFundingSourceCategory["TAX_RELATED"] = "TAX_RELATED";
    AssetVerificationFundingSourceCategory["EDUCATION"] = "EDUCATION";
    AssetVerificationFundingSourceCategory["GAMBLING_AND_GAMING"] = "GAMBLING_AND_GAMING";
    AssetVerificationFundingSourceCategory["ONLINE_PLATFORMS"] = "ONLINE_PLATFORMS";
    AssetVerificationFundingSourceCategory["CASH_DEPOSITS"] = "CASH_DEPOSITS";
    AssetVerificationFundingSourceCategory["REFUNDS_AND_CREDITS"] = "REFUNDS_AND_CREDITS";
    AssetVerificationFundingSourceCategory["MISCELLANEOUS"] = "MISCELLANEOUS";
})(AssetVerificationFundingSourceCategory || (exports.AssetVerificationFundingSourceCategory = AssetVerificationFundingSourceCategory = {}));
exports.ASSET_VERIFICATION_CATEGORY_TO_FUNDING_SOURCES = {
    [AssetVerificationFundingSourceCategory.EMPLOYMENT_AND_INCOME]: [
        documentUpload_1.DocumentUploadType.PAYROLL_DIRECT_DEPOSIT,
        documentUpload_1.DocumentUploadType.BONUS,
        documentUpload_1.DocumentUploadType.COMMISSION,
        documentUpload_1.DocumentUploadType.OVERTIME_PAY,
        documentUpload_1.DocumentUploadType.TIPS,
        documentUpload_1.DocumentUploadType.SEVERANCE_PAY,
        documentUpload_1.DocumentUploadType.PTO_PAY_OUT,
        documentUpload_1.DocumentUploadType.EXPENSE_REIMBURSEMENT,
        documentUpload_1.DocumentUploadType.INDEPENDENT_CONTRACTOR_INCOME,
        documentUpload_1.DocumentUploadType.SELF_EMPLOYMENT_BUSINESS_INCOME,
    ],
    [AssetVerificationFundingSourceCategory.RETIREMENT_AND_GOVERNMENT_BENEFITS]: [
        documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_RETIREMENT,
        documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_DISABILITY,
        documentUpload_1.DocumentUploadType.SUPPLEMENTAL_SECURITY_INCOME,
        documentUpload_1.DocumentUploadType.PENSION,
        documentUpload_1.DocumentUploadType.ANNUITY_PAYMENTS,
        documentUpload_1.DocumentUploadType.VETERANS_BENEFITS,
        documentUpload_1.DocumentUploadType.RAILROAD_RETIREMENT,
        documentUpload_1.DocumentUploadType.STATE_RETIREMENT_BENEFITS,
        documentUpload_1.DocumentUploadType.MILITARY_RETIREMENT,
    ],
    [AssetVerificationFundingSourceCategory.TRANSFERS]: [
        documentUpload_1.DocumentUploadType.TRANSFER_FROM_PERSONAL_ACCOUNT,
        documentUpload_1.DocumentUploadType.TRANSFER_FROM_JOINT_ACCOUNT,
        documentUpload_1.DocumentUploadType.BROKERAGE_ACCOUNT_TRANSFER,
        documentUpload_1.DocumentUploadType.SAVINGS_ACCOUNT_TRANSFER,
        documentUpload_1.DocumentUploadType.CREDIT_UNION_TRANSFER,
        documentUpload_1.DocumentUploadType.MONEY_MARKET_TRANSFER,
        documentUpload_1.DocumentUploadType.TRUST_ACCOUNT_TRANSFER,
        documentUpload_1.DocumentUploadType.CD_MATURITY_PROCEEDS,
        documentUpload_1.DocumentUploadType.INTERNATIONAL_WIRE_TRANSFER,
        documentUpload_1.DocumentUploadType.INTERNAL_BANK_TRANSFER,
    ],
    [AssetVerificationFundingSourceCategory.SALE_OF_ASSETS]: [
        documentUpload_1.DocumentUploadType.SALE_OF_HOME,
        documentUpload_1.DocumentUploadType.SALE_OF_LAND,
        documentUpload_1.DocumentUploadType.SALE_OF_VEHICLE,
        documentUpload_1.DocumentUploadType.SALE_OF_BOAT,
        documentUpload_1.DocumentUploadType.SALE_OF_RV,
        documentUpload_1.DocumentUploadType.SALE_OF_MOTORCYCLE,
        documentUpload_1.DocumentUploadType.SALE_OF_BUSINESS,
        documentUpload_1.DocumentUploadType.SALE_OF_STOCKS,
        documentUpload_1.DocumentUploadType.SALE_OF_BONDS,
        documentUpload_1.DocumentUploadType.SALE_OF_MUTUAL_FUNDS,
        documentUpload_1.DocumentUploadType.SALE_OF_CRYPTOCURRENCY,
        documentUpload_1.DocumentUploadType.SALE_OF_COLLECTIBLES,
        documentUpload_1.DocumentUploadType.ESTATE_SALE_PROCEEDS,
    ],
    [AssetVerificationFundingSourceCategory.INVESTMENTS]: [
        documentUpload_1.DocumentUploadType.STOCK_DIVIDENDS,
        documentUpload_1.DocumentUploadType.BOND_INTEREST,
        documentUpload_1.DocumentUploadType.MUTUAL_FUND_DISTRIBUTION,
        documentUpload_1.DocumentUploadType.CAPITAL_GAINS_DISTRIBUTION,
        documentUpload_1.DocumentUploadType.INVESTMENT_ACCOUNT_WITHDRAWAL,
        documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_DISTRIBUTION,
        documentUpload_1.DocumentUploadType.REQUIRED_MINIMUM_DISTRIBUTION,
    ],
    [AssetVerificationFundingSourceCategory.INSURANCE]: [
        documentUpload_1.DocumentUploadType.LIFE_INSURANCE_PAYOUT,
        documentUpload_1.DocumentUploadType.HEALTH_INSURANCE_REIMBURSEMENT,
        documentUpload_1.DocumentUploadType.AUTO_INSURANCE_CLAIM,
        documentUpload_1.DocumentUploadType.HOMEOWNERS_INSURANCE_CLAIM,
        documentUpload_1.DocumentUploadType.DISABILITY_INSURANCE_BENEFITS,
        documentUpload_1.DocumentUploadType.LONG_TERM_CARE_INSURANCE_PAYOUT,
    ],
    [AssetVerificationFundingSourceCategory.REAL_ESTATE]: [
        documentUpload_1.DocumentUploadType.RENTAL_INCOME,
        documentUpload_1.DocumentUploadType.SECURITY_DEPOSIT_REFUND,
        documentUpload_1.DocumentUploadType.ESCROW_REFUND,
        documentUpload_1.DocumentUploadType.PROPERTY_TAX_REFUND,
        documentUpload_1.DocumentUploadType.MORTGAGE_ESCROW_SURPLUS,
        documentUpload_1.DocumentUploadType.HOME_EQUITY_LOAN_PROCEEDS,
        documentUpload_1.DocumentUploadType.HELOC_ADVANCE,
        documentUpload_1.DocumentUploadType.CASH_OUT_REFINANCE_PROCEEDS,
        documentUpload_1.DocumentUploadType.HOME_SALE_PROCEEDS,
    ],
    [AssetVerificationFundingSourceCategory.LOANS]: [
        documentUpload_1.DocumentUploadType.PERSONAL_LOAN_PROCEEDS,
        documentUpload_1.DocumentUploadType.AUTO_LOAN_PROCEEDS,
        documentUpload_1.DocumentUploadType.STUDENT_LOAN_DISBURSEMENT,
        documentUpload_1.DocumentUploadType.BUSINESS_LOAN_PROCEEDS,
        documentUpload_1.DocumentUploadType.SBA_LOAN_PROCEEDS,
        documentUpload_1.DocumentUploadType.CONSTRUCTION_LOAN_DRAW,
        documentUpload_1.DocumentUploadType.PRIVATE_LOAN_FROM_FAMILY_FRIEND,
        documentUpload_1.DocumentUploadType.MARGIN_LOAN,
        documentUpload_1.DocumentUploadType.LINE_OF_CREDIT_ADVANCE,
    ],
    [AssetVerificationFundingSourceCategory.GIFTS_AND_FAMILY]: [
        documentUpload_1.DocumentUploadType.GIFT_FROM_FAMILY_MEMBER,
        documentUpload_1.DocumentUploadType.GIFT_FROM_FRIEND,
        documentUpload_1.DocumentUploadType.WEDDING_GIFT,
        documentUpload_1.DocumentUploadType.GRADUATION_GIFT,
        documentUpload_1.DocumentUploadType.BIRTHDAY_GIFT,
        documentUpload_1.DocumentUploadType.INHERITANCE,
        documentUpload_1.DocumentUploadType.TRUST_DISTRIBUTION,
    ],
    [AssetVerificationFundingSourceCategory.LEGAL_AND_SETTLEMENT]: [
        documentUpload_1.DocumentUploadType.LAWSUIT_SETTLEMENT,
        documentUpload_1.DocumentUploadType.CLASS_ACTION_SETTLEMENT,
        documentUpload_1.DocumentUploadType.WORKERS_COMPENSATION_SETTLEMENT,
        documentUpload_1.DocumentUploadType.PERSONAL_INJURY_SETTLEMENT,
        documentUpload_1.DocumentUploadType.DIVORCE_SETTLEMENT,
        documentUpload_1.DocumentUploadType.CHILD_SUPPORT_PAYMENT,
        documentUpload_1.DocumentUploadType.ALIMONY,
        documentUpload_1.DocumentUploadType.ESTATE_DISTRIBUTION,
    ],
    [AssetVerificationFundingSourceCategory.BUSINESS]: [
        documentUpload_1.DocumentUploadType.CUSTOMER_PAYMENTS,
        documentUpload_1.DocumentUploadType.MERCHANT_SERVICES_DEPOSITS,
        documentUpload_1.DocumentUploadType.ACCOUNTS_RECEIVABLE_COLLECTIONS,
        documentUpload_1.DocumentUploadType.VENDOR_REFUND,
        documentUpload_1.DocumentUploadType.TAX_REFUND_TO_BUSINESS,
        documentUpload_1.DocumentUploadType.OWNER_CONTRIBUTION,
        documentUpload_1.DocumentUploadType.PARTNER_CAPITAL_CONTRIBUTION,
        documentUpload_1.DocumentUploadType.BUSINESS_INSURANCE_CLAIM,
    ],
    [AssetVerificationFundingSourceCategory.TAX_RELATED]: [
        documentUpload_1.DocumentUploadType.FEDERAL_INCOME_TAX_REFUND,
        documentUpload_1.DocumentUploadType.STATE_INCOME_TAX_REFUND,
        documentUpload_1.DocumentUploadType.SALES_TAX_REFUND,
        documentUpload_1.DocumentUploadType.IRS_CREDIT_OR_REBATE,
    ],
    [AssetVerificationFundingSourceCategory.EDUCATION]: [
        documentUpload_1.DocumentUploadType.STUDENT_FINANCIAL_AID_REFUND,
        documentUpload_1.DocumentUploadType.SCHOLARSHIP_REFUND,
        documentUpload_1.DocumentUploadType.GRANT_PROCEEDS,
        documentUpload_1.DocumentUploadType.TUITION_REIMBURSEMENT,
    ],
    [AssetVerificationFundingSourceCategory.GAMBLING_AND_GAMING]: [
        documentUpload_1.DocumentUploadType.CASINO_WINNINGS,
        documentUpload_1.DocumentUploadType.LOTTERY_WINNINGS,
        documentUpload_1.DocumentUploadType.SPORTS_BETTING_WINNINGS,
        documentUpload_1.DocumentUploadType.POKER_TOURNAMENT_WINNINGS,
        documentUpload_1.DocumentUploadType.SWEEPSTAKES_PRIZE,
    ],
    [AssetVerificationFundingSourceCategory.ONLINE_PLATFORMS]: [
        documentUpload_1.DocumentUploadType.PAYPAL_TRANSFER,
        documentUpload_1.DocumentUploadType.VENMO_TRANSFER,
        documentUpload_1.DocumentUploadType.CASH_APP_TRANSFER,
        documentUpload_1.DocumentUploadType.ZELLE_PAYMENT,
        documentUpload_1.DocumentUploadType.STRIPE_PAYOUT,
        documentUpload_1.DocumentUploadType.SQUARE_PAYOUT,
        documentUpload_1.DocumentUploadType.ETSY_PAYOUT,
        documentUpload_1.DocumentUploadType.EBAY_PAYOUT,
        documentUpload_1.DocumentUploadType.AMAZON_SELLER_PAYOUT,
        documentUpload_1.DocumentUploadType.AIRBNB_PAYOUT,
        documentUpload_1.DocumentUploadType.VRBO_PAYOUT,
        documentUpload_1.DocumentUploadType.UBER_LYFT_EARNINGS,
        documentUpload_1.DocumentUploadType.DOOR_DASH_INSTACART_EARNINGS,
    ],
    [AssetVerificationFundingSourceCategory.CASH_DEPOSITS]: [
        documentUpload_1.DocumentUploadType.PERSONAL_CASH_SAVINGS,
        documentUpload_1.DocumentUploadType.CASH_FROM_BUSINESS_RECEIPTS,
        documentUpload_1.DocumentUploadType.CASH_GIFT,
        documentUpload_1.DocumentUploadType.CASH_FROM_SALE_OF_PERSONAL_PROPERTY,
    ],
    [AssetVerificationFundingSourceCategory.REFUNDS_AND_CREDITS]: [
        documentUpload_1.DocumentUploadType.MERCHANT_REFUND,
        documentUpload_1.DocumentUploadType.CREDIT_CARD_REFUND,
        documentUpload_1.DocumentUploadType.UTILITY_DEPOSIT_REFUND,
        documentUpload_1.DocumentUploadType.WARRANTY_REIMBURSEMENT,
        documentUpload_1.DocumentUploadType.MANUFACTURER_REBATE,
    ],
    [AssetVerificationFundingSourceCategory.MISCELLANEOUS]: [
        documentUpload_1.DocumentUploadType.PRIZE_OR_AWARD,
        documentUpload_1.DocumentUploadType.ROYALTIES,
        documentUpload_1.DocumentUploadType.LICENSING_INCOME,
        documentUpload_1.DocumentUploadType.PATENT_INCOME,
        documentUpload_1.DocumentUploadType.COPYRIGHT_INCOME,
        documentUpload_1.DocumentUploadType.MINERAL_OR_OIL_RIGHTS_ROYALTIES,
        documentUpload_1.DocumentUploadType.CROWDFUNDING_PROCEEDS,
        documentUpload_1.DocumentUploadType.CHARITABLE_GRANT,
        documentUpload_1.DocumentUploadType.CHURCH_ASSISTANCE,
        documentUpload_1.DocumentUploadType.DISASTER_RELIEF_FUNDS,
        documentUpload_1.DocumentUploadType.FOREIGN_CURRENCY_EXCHANGE_PROCEEDS,
    ],
};
// The proof-document types an applicant can upload to verify a flagged transaction's fund source.
// TypeScript enums cannot extend another enum, so instead of duplicating these values (they already
// live on DocumentUploadType, which is what document_upload.type actually stores) this is a derived
// SUBSET of DocumentUploadType — the single source of truth per aven_types/AGENTS.md. AssetFundingSourceDocumentType
// is the union type narrowed to exactly these members, assignable to DocumentUploadType but not vice versa.
exports.ASSET_FUNDING_SOURCE_DOCUMENT_TYPES = [
    documentUpload_1.DocumentUploadType.PAY_STUB,
    documentUpload_1.DocumentUploadType.W2,
    documentUpload_1.DocumentUploadType.FORM_1099,
    documentUpload_1.DocumentUploadType.BANK_STATEMENT,
    documentUpload_1.DocumentUploadType.DEPOSIT_RECEIPT,
    documentUpload_1.DocumentUploadType.WIRE_CONFIRMATION,
    documentUpload_1.DocumentUploadType.GIFT_LETTER,
    documentUpload_1.DocumentUploadType.BILL_OF_SALE,
    documentUpload_1.DocumentUploadType.SETTLEMENT_STATEMENT,
    documentUpload_1.DocumentUploadType.ESCROW_STATEMENT,
    documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT,
    documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT,
    documentUpload_1.DocumentUploadType.TAX_RETURN,
    documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION,
    documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS,
    documentUpload_1.DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS,
    documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE,
    documentUpload_1.DocumentUploadType.INHERITANCE_DOCUMENTATION,
    documentUpload_1.DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT,
    documentUpload_1.DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS,
];
exports.supportedFirstLienPurchaseDocuments = Object.fromEntries(exports.ASSET_FUNDING_SOURCE_DOCUMENT_TYPES.map((documentType) => [documentUpload_1.documentPathForType[documentType], documentType]));
exports.ASSET_VERIFICATION_FUNDING_SOURCE_TO_DOCUMENT_TYPES = {
    // Employment & Income
    [documentUpload_1.DocumentUploadType.PAYROLL_DIRECT_DEPOSIT]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.BONUS]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.COMMISSION]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.OVERTIME_PAY]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.TIPS]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SEVERANCE_PAY]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.PTO_PAY_OUT]: [documentUpload_1.DocumentUploadType.PAY_STUB, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.EXPENSE_REIMBURSEMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT],
    [documentUpload_1.DocumentUploadType.INDEPENDENT_CONTRACTOR_INCOME]: [documentUpload_1.DocumentUploadType.FORM_1099, documentUpload_1.DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT],
    [documentUpload_1.DocumentUploadType.SELF_EMPLOYMENT_BUSINESS_INCOME]: [documentUpload_1.DocumentUploadType.TAX_RETURN, documentUpload_1.DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS],
    // Retirement & Government Benefits
    [documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_RETIREMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SOCIAL_SECURITY_DISABILITY]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SUPPLEMENTAL_SECURITY_INCOME]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.PENSION]: [documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ANNUITY_PAYMENTS]: [documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.VETERANS_BENEFITS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.RAILROAD_RETIREMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.STATE_RETIREMENT_BENEFITS]: [documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.MILITARY_RETIREMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Transfers
    [documentUpload_1.DocumentUploadType.TRANSFER_FROM_PERSONAL_ACCOUNT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.TRANSFER_FROM_JOINT_ACCOUNT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.BROKERAGE_ACCOUNT_TRANSFER]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SAVINGS_ACCOUNT_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.CREDIT_UNION_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.MONEY_MARKET_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.TRUST_ACCOUNT_TRANSFER]: [documentUpload_1.DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.CD_MATURITY_PROCEEDS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.INTERNATIONAL_WIRE_TRANSFER]: [documentUpload_1.DocumentUploadType.WIRE_CONFIRMATION, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.INTERNAL_BANK_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Sale of Assets
    [documentUpload_1.DocumentUploadType.SALE_OF_HOME]: [documentUpload_1.DocumentUploadType.SETTLEMENT_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALE_OF_LAND]: [documentUpload_1.DocumentUploadType.SETTLEMENT_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALE_OF_VEHICLE]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE],
    [documentUpload_1.DocumentUploadType.SALE_OF_BOAT]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE],
    [documentUpload_1.DocumentUploadType.SALE_OF_RV]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE],
    [documentUpload_1.DocumentUploadType.SALE_OF_MOTORCYCLE]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE],
    [documentUpload_1.DocumentUploadType.SALE_OF_BUSINESS]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE, documentUpload_1.DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS],
    [documentUpload_1.DocumentUploadType.SALE_OF_STOCKS]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALE_OF_BONDS]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALE_OF_MUTUAL_FUNDS]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALE_OF_CRYPTOCURRENCY]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALE_OF_COLLECTIBLES]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE],
    [documentUpload_1.DocumentUploadType.ESTATE_SALE_PROCEEDS]: [documentUpload_1.DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS, documentUpload_1.DocumentUploadType.BILL_OF_SALE],
    // Investments
    [documentUpload_1.DocumentUploadType.STOCK_DIVIDENDS]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.BOND_INTEREST]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.MUTUAL_FUND_DISTRIBUTION]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.CAPITAL_GAINS_DISTRIBUTION]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.INVESTMENT_ACCOUNT_WITHDRAWAL]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_DISTRIBUTION]: [documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT],
    [documentUpload_1.DocumentUploadType.REQUIRED_MINIMUM_DISTRIBUTION]: [documentUpload_1.DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT],
    // Insurance
    [documentUpload_1.DocumentUploadType.LIFE_INSURANCE_PAYOUT]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    [documentUpload_1.DocumentUploadType.HEALTH_INSURANCE_REIMBURSEMENT]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    [documentUpload_1.DocumentUploadType.AUTO_INSURANCE_CLAIM]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    [documentUpload_1.DocumentUploadType.HOMEOWNERS_INSURANCE_CLAIM]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    [documentUpload_1.DocumentUploadType.DISABILITY_INSURANCE_BENEFITS]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    [documentUpload_1.DocumentUploadType.LONG_TERM_CARE_INSURANCE_PAYOUT]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    // Real Estate
    [documentUpload_1.DocumentUploadType.RENTAL_INCOME]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.TAX_RETURN],
    [documentUpload_1.DocumentUploadType.SECURITY_DEPOSIT_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ESCROW_REFUND]: [documentUpload_1.DocumentUploadType.ESCROW_STATEMENT],
    [documentUpload_1.DocumentUploadType.PROPERTY_TAX_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.MORTGAGE_ESCROW_SURPLUS]: [documentUpload_1.DocumentUploadType.ESCROW_STATEMENT],
    [documentUpload_1.DocumentUploadType.HOME_EQUITY_LOAN_PROCEEDS]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.HELOC_ADVANCE]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.CASH_OUT_REFINANCE_PROCEEDS]: [documentUpload_1.DocumentUploadType.SETTLEMENT_STATEMENT],
    [documentUpload_1.DocumentUploadType.HOME_SALE_PROCEEDS]: [documentUpload_1.DocumentUploadType.SETTLEMENT_STATEMENT],
    // Loans
    [documentUpload_1.DocumentUploadType.PERSONAL_LOAN_PROCEEDS]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.AUTO_LOAN_PROCEEDS]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.STUDENT_LOAN_DISBURSEMENT]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.BUSINESS_LOAN_PROCEEDS]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.SBA_LOAN_PROCEEDS]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.CONSTRUCTION_LOAN_DRAW]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE],
    [documentUpload_1.DocumentUploadType.PRIVATE_LOAN_FROM_FAMILY_FRIEND]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE, documentUpload_1.DocumentUploadType.GIFT_LETTER],
    [documentUpload_1.DocumentUploadType.MARGIN_LOAN]: [documentUpload_1.DocumentUploadType.BROKERAGE_STATEMENT],
    [documentUpload_1.DocumentUploadType.LINE_OF_CREDIT_ADVANCE]: [documentUpload_1.DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Gifts & Family
    [documentUpload_1.DocumentUploadType.GIFT_FROM_FAMILY_MEMBER]: [documentUpload_1.DocumentUploadType.GIFT_LETTER, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.GIFT_FROM_FRIEND]: [documentUpload_1.DocumentUploadType.GIFT_LETTER, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.WEDDING_GIFT]: [documentUpload_1.DocumentUploadType.GIFT_LETTER],
    [documentUpload_1.DocumentUploadType.GRADUATION_GIFT]: [documentUpload_1.DocumentUploadType.GIFT_LETTER],
    [documentUpload_1.DocumentUploadType.BIRTHDAY_GIFT]: [documentUpload_1.DocumentUploadType.GIFT_LETTER],
    [documentUpload_1.DocumentUploadType.INHERITANCE]: [documentUpload_1.DocumentUploadType.INHERITANCE_DOCUMENTATION, documentUpload_1.DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS],
    [documentUpload_1.DocumentUploadType.TRUST_DISTRIBUTION]: [documentUpload_1.DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS],
    // Legal & Settlement
    [documentUpload_1.DocumentUploadType.LAWSUIT_SETTLEMENT]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS],
    [documentUpload_1.DocumentUploadType.CLASS_ACTION_SETTLEMENT]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS],
    [documentUpload_1.DocumentUploadType.WORKERS_COMPENSATION_SETTLEMENT]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS],
    [documentUpload_1.DocumentUploadType.PERSONAL_INJURY_SETTLEMENT]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS],
    [documentUpload_1.DocumentUploadType.DIVORCE_SETTLEMENT]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS],
    [documentUpload_1.DocumentUploadType.CHILD_SUPPORT_PAYMENT]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ALIMONY]: [documentUpload_1.DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ESTATE_DISTRIBUTION]: [documentUpload_1.DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS],
    // Business
    [documentUpload_1.DocumentUploadType.CUSTOMER_PAYMENTS]: [documentUpload_1.DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.MERCHANT_SERVICES_DEPOSITS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ACCOUNTS_RECEIVABLE_COLLECTIONS]: [documentUpload_1.DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT],
    [documentUpload_1.DocumentUploadType.VENDOR_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.TAX_REFUND_TO_BUSINESS]: [documentUpload_1.DocumentUploadType.TAX_RETURN, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.OWNER_CONTRIBUTION]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS],
    [documentUpload_1.DocumentUploadType.PARTNER_CAPITAL_CONTRIBUTION]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS],
    [documentUpload_1.DocumentUploadType.BUSINESS_INSURANCE_CLAIM]: [documentUpload_1.DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION],
    // Tax-Related
    [documentUpload_1.DocumentUploadType.FEDERAL_INCOME_TAX_REFUND]: [documentUpload_1.DocumentUploadType.TAX_RETURN, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.STATE_INCOME_TAX_REFUND]: [documentUpload_1.DocumentUploadType.TAX_RETURN, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SALES_TAX_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.IRS_CREDIT_OR_REBATE]: [documentUpload_1.DocumentUploadType.TAX_RETURN, documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Education
    [documentUpload_1.DocumentUploadType.STUDENT_FINANCIAL_AID_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SCHOLARSHIP_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.GRANT_PROCEEDS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.TUITION_REIMBURSEMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Gambling & Gaming
    [documentUpload_1.DocumentUploadType.CASINO_WINNINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.LOTTERY_WINNINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SPORTS_BETTING_WINNINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.POKER_TOURNAMENT_WINNINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SWEEPSTAKES_PRIZE]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Online Platforms
    [documentUpload_1.DocumentUploadType.PAYPAL_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.VENMO_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.CASH_APP_TRANSFER]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ZELLE_PAYMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.STRIPE_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.SQUARE_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ETSY_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.EBAY_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.AMAZON_SELLER_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.AIRBNB_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.VRBO_PAYOUT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.UBER_LYFT_EARNINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.DOOR_DASH_INSTACART_EARNINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Cash Deposits
    [documentUpload_1.DocumentUploadType.PERSONAL_CASH_SAVINGS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.DEPOSIT_RECEIPT],
    [documentUpload_1.DocumentUploadType.CASH_FROM_BUSINESS_RECEIPTS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.DEPOSIT_RECEIPT],
    [documentUpload_1.DocumentUploadType.CASH_GIFT]: [documentUpload_1.DocumentUploadType.GIFT_LETTER, documentUpload_1.DocumentUploadType.DEPOSIT_RECEIPT],
    [documentUpload_1.DocumentUploadType.CASH_FROM_SALE_OF_PERSONAL_PROPERTY]: [documentUpload_1.DocumentUploadType.BILL_OF_SALE, documentUpload_1.DocumentUploadType.DEPOSIT_RECEIPT],
    // Refunds & Credits
    [documentUpload_1.DocumentUploadType.MERCHANT_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.CREDIT_CARD_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.UTILITY_DEPOSIT_REFUND]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.WARRANTY_REIMBURSEMENT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.MANUFACTURER_REBATE]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    // Miscellaneous
    [documentUpload_1.DocumentUploadType.PRIZE_OR_AWARD]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.ROYALTIES]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.FORM_1099],
    [documentUpload_1.DocumentUploadType.LICENSING_INCOME]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.FORM_1099],
    [documentUpload_1.DocumentUploadType.PATENT_INCOME]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.FORM_1099],
    [documentUpload_1.DocumentUploadType.COPYRIGHT_INCOME]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.FORM_1099],
    [documentUpload_1.DocumentUploadType.MINERAL_OR_OIL_RIGHTS_ROYALTIES]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.FORM_1099],
    [documentUpload_1.DocumentUploadType.CROWDFUNDING_PROCEEDS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.CHARITABLE_GRANT]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.CHURCH_ASSISTANCE]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.DISASTER_RELIEF_FUNDS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT],
    [documentUpload_1.DocumentUploadType.FOREIGN_CURRENCY_EXCHANGE_PROCEEDS]: [documentUpload_1.DocumentUploadType.BANK_STATEMENT, documentUpload_1.DocumentUploadType.WIRE_CONFIRMATION],
};
/**
 * The pre-defined issues an LO/Ops reviewer can select when rejecting a flagged asset transaction, surfaced as a
 * Retool dropdown. Each maps to a customer-facing sentence in HUMAN_READABLE_ASSET_VERIFICATION_DENIAL_REASON. When
 * the reviewer needs a reason not covered here, they instead type a manual note (the "[Manual input]" case in the
 * design), which is stored as the customer-facing free-text rationale rather than as an enum value.
 */
var AssetVerificationDenialReason;
(function (AssetVerificationDenialReason) {
    AssetVerificationDenialReason["UNABLE_TO_VERIFY"] = "UNABLE_TO_VERIFY";
    AssetVerificationDenialReason["MISSING_PAGES"] = "MISSING_PAGES";
    AssetVerificationDenialReason["DOC_TYPE_NOT_ALLOWED"] = "DOC_TYPE_NOT_ALLOWED";
    AssetVerificationDenialReason["DUPLICATE"] = "DUPLICATE";
    AssetVerificationDenialReason["NON_APPLICANT"] = "NON_APPLICANT";
    AssetVerificationDenialReason["OUTDATED"] = "OUTDATED";
    AssetVerificationDenialReason["BLURRY_OR_CROPPED"] = "BLURRY_OR_CROPPED";
    AssetVerificationDenialReason["AUTHENTICITY_UNVERIFIED"] = "AUTHENTICITY_UNVERIFIED";
    AssetVerificationDenialReason["SCREENSHOT_OR_PICTURE_OF_SCREEN"] = "SCREENSHOT_OR_PICTURE_OF_SCREEN";
    AssetVerificationDenialReason["NAME_MISMATCH"] = "NAME_MISMATCH";
    AssetVerificationDenialReason["PASSWORD_PROTECTED"] = "PASSWORD_PROTECTED";
    AssetVerificationDenialReason["MISSING_INFORMATION"] = "MISSING_INFORMATION";
})(AssetVerificationDenialReason || (exports.AssetVerificationDenialReason = AssetVerificationDenialReason = {}));
// Customer-facing sentence shown to the applicant for each denial reason (e.g. in the re-upload email "Issue:" line).
exports.HUMAN_READABLE_ASSET_VERIFICATION_DENIAL_REASON = {
    [AssetVerificationDenialReason.UNABLE_TO_VERIFY]: 'We were unable to verify the information.',
    [AssetVerificationDenialReason.MISSING_PAGES]: 'The document was missing pages. We require all pages of the requested document.',
    [AssetVerificationDenialReason.DOC_TYPE_NOT_ALLOWED]: 'The document type is not allowed.',
    [AssetVerificationDenialReason.DUPLICATE]: 'The document was a duplicate.',
    [AssetVerificationDenialReason.NON_APPLICANT]: 'The document was for a non-applicant.',
    [AssetVerificationDenialReason.OUTDATED]: 'The document was outdated.',
    [AssetVerificationDenialReason.BLURRY_OR_CROPPED]: 'The document was blurry and/or cropped.',
    [AssetVerificationDenialReason.AUTHENTICITY_UNVERIFIED]: "We could not verify the document's authenticity.",
    [AssetVerificationDenialReason.SCREENSHOT_OR_PICTURE_OF_SCREEN]: 'The document was a screenshot or picture of a screen.',
    [AssetVerificationDenialReason.NAME_MISMATCH]: "The document name did not match the applicant's.",
    [AssetVerificationDenialReason.PASSWORD_PROTECTED]: 'The document was password protected.',
    [AssetVerificationDenialReason.MISSING_INFORMATION]: 'The document was missing information.',
};
/** Whether a single transaction funding source was applied to its transaction or skipped during review. */
var FundingSourceReviewStatus;
(function (FundingSourceReviewStatus) {
    FundingSourceReviewStatus["applied"] = "applied";
    FundingSourceReviewStatus["skipped"] = "skipped";
})(FundingSourceReviewStatus || (exports.FundingSourceReviewStatus = FundingSourceReviewStatus = {}));
/** Why a single transaction funding source was not applied to its transaction during review. */
var FundingSourceReviewSkipReason;
(function (FundingSourceReviewSkipReason) {
    FundingSourceReviewSkipReason["transactionNotFlaggedOnLoanApplication"] = "transactionNotFlaggedOnLoanApplication";
    FundingSourceReviewSkipReason["alreadyMatchesExistingSelection"] = "alreadyMatchesExistingSelection";
})(FundingSourceReviewSkipReason || (exports.FundingSourceReviewSkipReason = FundingSourceReviewSkipReason = {}));
